export var getSuggestionByGlobalIndex = function getSuggestionByGlobalIndex(groups, globalIndex) {
  return groups.map(function (group) {
    return group.suggestions;
  }).flat().find(function (item) {
    return item.globalIndex === globalIndex;
  });
};